import * as Yup from 'yup'
import { parseCLP } from '../utils/currency'

// Un solo box de servicios contratados por cliente.
// - Box vacío (sin nada seleccionado): válido, se trata como "sin servicios".
// - Box iniciado: exige servicios, frecuencia y valor; si incluye
//   "Otros servicios", exige al menos un otro servicio.
export const contractedServicesFieldSchema = Yup.array().test(
  'validate-contracted-services',
  'Servicios contratados inválidos',
  function (services) {
    const errors = []

    ;(services || []).forEach((service, index) => {
      const types = service?.service_types || []
      const others = (service?.other_services || [])
        .map((text) => (text || '').trim())
        .filter(Boolean)
      const hasValue = parseCLP(service?.billable_value) > 0
      const hasData =
        types.length > 0 || service?.frequency || hasValue || others.length > 0

      if (!hasData) return

      if (!types.length) {
        errors.push(
          this.createError({
            path: `contracted_services[${index}].service_types`,
            message: 'Seleccione al menos un servicio'
          })
        )
      }

      if (!service?.frequency) {
        errors.push(
          this.createError({
            path: `contracted_services[${index}].frequency`,
            message: 'Seleccione frecuencia'
          })
        )
      }

      if (!hasValue) {
        errors.push(
          this.createError({
            path: `contracted_services[${index}].billable_value`,
            message: 'Ingrese un valor mayor a 0'
          })
        )
      }

      if (types.includes('OTROS_SERVICIOS') && !others.length) {
        errors.push(
          this.createError({
            path: `contracted_services[${index}].other_services`,
            message: 'Agregue al menos un otro servicio'
          })
        )
      }
    })

    if (errors.length) {
      return new Yup.ValidationError(errors)
    }

    return true
  }
)
